var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 110.3V55.2h1.3v55.1h-1.3Z",
    fill: "#8C9FAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 55.9v-1.4h55v1.3H0Z",
    fill: "#8C9FAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29 84.7-3.4-3.4 27.8-27.9L57 57 29 84.7Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m55.7 55.6-1-1L82.3 27l1 1-27.6 27.6Z",
    fill: "#8C9FAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.3 57.6H52.7V0h4.9v52.7h52.7v4.9Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.c21d950a207ffc722712b09c84cab109.svg";
export { ForwardRef as ReactComponent };